import { getCompanyRelatedData } from '../shared/companies';
export const getDefaultUserAssociationModel = () => ({
    clientId: null,
    clientName: '',
    companyId: null,
    companyName: '',
    roleId: null
});
export const getDefaultUserModel = (userAssociations = [getDefaultUserAssociationModel()]) => ({
    email: '',
    firstName: '',
    lastName: '',
    userAssociations: userAssociations
});
export const getEditUserFormModelFromUserDetails = (userDetails, clientCompaniesRoles) => ({
    ...userDetails,
    userAssociations: getEditUserAssociations(userDetails.userAssociations, clientCompaniesRoles)
});
const getEditUserAssociations = (initialUserAssociations, clientCompaniesRoles) => initialUserAssociations.map(association => {
    const { roles } = getCompanyRelatedData(clientCompaniesRoles, association.clientId, association.companyId);
    const isInvalidRole = !roles.includes(association.roleId);
    return {
        ...association,
        roleId: isInvalidRole ? null : association.roleId
    };
});
export const getDefaultUsersFilterFormModelState = () => ({
    status: []
});
